import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useEffect } from 'react'
import { Route, Routes } from 'react-router'
import { BrowserRouter } from 'react-router'
import { Outlet } from 'react-router'

import { DesignSystem } from '~/DesignSystem'
import Intl from '~/Intl'

import BugSnag from '../BugSnag'
import AuthProvider from './Auth/AuthProvider'
import LoadingAuth from './Auth/components/LoadingAuth'
import NotFoundPage from './pages/404'
import ErrorPage from './pages/500'
import AuthAppIdPage from './pages/auth/:appId'
import ProductIdPage from './pages/products/:productId'
import AddProductSuccessPage from './pages/products/:productId/add/success'
import SurveyPage from './pages/survey'
import SurveySuccessPage from './pages/survey/success'
import LoadingStore from './Store/components/LoadingStore'
import StoreIntl from './Store/components/StoreIntl'
import StoreProvider from './Store/CurrentStoreProvider'

export const Paths = {
  auth: '/auth/:appId',
  product: '/:flow/products/:productId',
  addProductSuccess: '/:flow/products/:productId/success',
  survey: '/survey',
  surveySuccess: '/survey/success',
} as const

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 0,
    },
  },
})

const App = () => {
  useEffect(() => {
    window.document.getElementsByTagName('html')[0]?.classList.remove('loading')
  }, [])
  return (
    <BugSnag FallbackComponent={ErrorPage}>
      <QueryClientProvider client={queryClient}>
        <Intl>
          <DesignSystem primary="#389E0D">
            <AuthProvider>
              <BrowserRouter>
                <Routes>
                  <Route path={Paths.auth} Component={AuthAppIdPage} />
                  <Route
                    element={
                      <LoadingAuth>
                        <StoreProvider>
                          <LoadingStore>
                            <StoreIntl>
                              <Outlet />
                            </StoreIntl>
                          </LoadingStore>
                        </StoreProvider>
                      </LoadingAuth>
                    }
                  >
                    <Route path={Paths.surveySuccess} Component={SurveySuccessPage} />
                    <Route path={Paths.survey} Component={SurveyPage} />
                    <Route path={Paths.product} Component={ProductIdPage} />
                    <Route path={Paths.addProductSuccess} Component={AddProductSuccessPage} />
                  </Route>
                  <Route path="*" element={<NotFoundPage />} />
                </Routes>
              </BrowserRouter>
            </AuthProvider>
          </DesignSystem>
        </Intl>
      </QueryClientProvider>
    </BugSnag>
  )
}

export default App
